import style from "./style/Resume.module.css";
import pageStyle from "./style/Page.module.css";

function CV() {
  return (
    <div className={pageStyle.page}>
      <object
        className={style.resumeFrame}
        aria-label="CV"
        width="100%"
        height="100%"
        data={"/CV.pdf"}
        type="application/pdf"
      >
        <p>
          It seems your browser cannot display the PDF.{" "}
          <a href="/CV.pdf" download>Click here to download it.</a>
        </p>
      </object>
    </div>
  );
}

export default CV;
